import Quill from "quill";

export const MANUAL_NUMBERING_CLASS = "ql-manual-numbering";

// Matches any leading run of digits, dots and spaces, e.g. "1.", "1.2", "1. 2 .3 ".
const MANUAL_NUMBERING_PATTERN = /^[\s\u00a0]*\d[\d.\s\u00a0]*/;

const isManuallyNumbered = (paragraph: HTMLElement): boolean =>
  MANUAL_NUMBERING_PATTERN.test(paragraph.textContent ?? "");

const refresh = (root: HTMLElement): void => {
  root.querySelectorAll<HTMLElement>("p").forEach((paragraph) => {
    const shouldMark = isManuallyNumbered(paragraph);
    // Guard against redundant DOM writes so we don't fight Quill's own rendering.
    if (shouldMark !== paragraph.classList.contains(MANUAL_NUMBERING_CLASS)) {
      paragraph.classList.toggle(MANUAL_NUMBERING_CLASS, shouldMark);
    }
  });
};

/**
 * Flags paragraphs whose text starts with a manual hierarchical number
 * (e.g. "1.2.3 Title") by adding {@link MANUAL_NUMBERING_CLASS}, so they can be
 * highlighted in CSS.
 */
export function markManualNumbering(quill: Quill): void {
  const root = quill.root;
  refresh(root);
  quill.on("text-change", () => refresh(root));
}
